import React from 'react';
import { Home, Box, MapPin } from 'lucide-react';

const Sidebar = ({ view, setView }) => (
  <aside className="sidebar" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
    <div className="sidebar-content" style={{ flex: 1 }}>
      <div className="logo" style={{ marginTop: 24 }}>
        <img src="/images/logo Black.gif" alt="THE ENCLAVE" style={{ width: '100%' }} />
      </div>
      <button className={`nav-btn ${view === 'home' ? 'active' : ''}`} onClick={() => setView('home')}>
        <Home size={18} /> Home
      </button>
      <button className={`nav-btn ${view === 'inventory' ? 'active' : ''}`} onClick={() => setView('inventory')}>
         Available Units
      </button>
      <button className={`nav-btn ${view === 'tour' ? 'active' : ''}`} onClick={() => setView('tour')}>
        <Box size={18} /> 3D Virtual Tour
      </button>
      <button className={`nav-btn ${view === 'location' ? 'active' : ''}`} onClick={() => setView('location')}>
        <MapPin size={18} /> Location
      </button>
      <button className={`nav-btn ${view === 'wellness' ? 'active' : ''}`} onClick={() => setView('wellness')}>
        Wellness & Social Spaces
      </button>
      <div className="sidebar-footer">
        <div style={{ fontSize: '0.8rem', opacity: 0.7, marginBottom: '1rem' }}>
          <p>Total Units: 70</p>
          <p>Location: 22 Dinberua Area, Addis Ababa,Ethiopia</p>
        </div>
      </div>
    </div>
    <div style={{ marginTop: 'auto', marginBottom: '1.5rem', width: '100%', textAlign: 'center', fontSize: '1rem' }}>
      For detail information click <a href="/info.html" style={{ color: '#ffe082', textDecoration: 'underline', fontWeight: 'bold' }}>here</a>
    </div>
  </aside>
);

export default Sidebar;
